export const tableDataSchemas = [
  {
    prop: 'creatorId',
    label: '操作人',
    minWidth: 150
  },
  {
    prop: 'createTime',
    label: '操作时间',
    minWidth: 120
  },
  {
    prop: 'title',
    label: '标题',
    minWidth: 60
  },
  {
    prop: 'remoteAddr',
    label: 'ip地址',
    minWidth: 60
  },
  {
    prop: 'requestUri',
    label: '请求URI',
    minWidth: 150
  },
  {
    prop: 'method',
    label: '操作方式',
    minWidth: 60
  },
  {
    prop: 'time',
    label: '执行时间',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    btnArr: ['info']
  }
]
